define('customPlugins/atnKoHighchart',['knockout', 'jquery', 'lodash', 'canvg', './utils'],
  function (ko, $, _, canvg, utils) {
      'use strict';
      ko.bindingHandlers.atnKoHighchart = bindHighchart();
      return;

      function bindHighchart() {
          /*jshint validthis:true */
          var highchartBinding, self = this;
          return {
              init: init,
              update: update
          };

          function init() {
              highchartBinding = createHighcharts();
              highchartBinding.init.apply(self, arguments);
          }

          function update() {
              highchartBinding.update.apply(self, arguments);
          }
      }

      function createHighcharts() {
          var domElement;

          return {
              init: init,
              update: update
          };

          function init() {

          }

          function update(element, valueAccessor) {
              domElement = element;
              var value = valueAccessor(),
                modelData = value.model.modelData;

              //! ToDo
              var ccc = valueAccessor().model.isLoading();

              if (modelData && !_.isEmpty(modelData)) {
                  var chartObj = computeGraphObject(value, domElement);


                  //  adding functionality to get dataURL
                  if (!_.isFunction(value.highchartToJPEG)) {
                      value.highchartToJPEG = createHighchartToJpegFn(element, chartObj, arguments);
                      value.hasChartToDisplay = createHasChartToDisplay(element, chartObj);
                  }

                  if ($(domElement).highcharts()) {
                      $(domElement).highcharts().destroy();
                  }
                  $(domElement).highcharts(chartObj);
              }
          }


          /**
           * function to create function that check if highchart has chart to display
           * @param  {DOMElement} element         the current element on which the highchart is drawn
           * @param  {object} options             option related to the highchart
           * @return {function}                   function to check if highchart has chart to display
           */
          function createHasChartToDisplay(element, options) {
              var hasPie = options.hasPie, isPie = options.isPie;
              /**
               * function to check if highchart has chart to hasDataToDisplay
               * @return {boolean} true if chart has chart to display
               */
              return function () {
                  return utils.checkChartHasData($(element).highcharts(), isPie);
              };
          }

          /**
           * function to create function for creating JPEG snapsort of the given highchart
           * @param  {DOMElement} element         the current element on which the highchart is drawn
           * @param  {object} options             option related to the highchart
           * @param  {Array[Object]} args         argmuments for the update function
           * @return {function}                   function for creating JPEG snapsort of the given highchart
           */
          function createHighchartToJpegFn(element, options, args) {
              var needTransform = false,
                xDelta = 0,
                yDelta = 0,
                hasPie = options.hasPie,
                isPie = options.isPie;

              if (options.xAxis) {
                  needTransform = !options.xAxis.labels.autoTransform;
                  xDelta = options.xAxis.labels.x;
                  yDelta = options.xAxis.labels.y;
              }

              /**
               * function to give image corresponding to the given chart
               * @param  {number} actualWidth  required width of the image
               * @param  {number} actualHeight required height of the image
               * @return {string}              dataURI of the image crated after taking snapsort of the graph
               */
              return function (actualWidth, actualHeight, type) {
                  var canvas = document.createElement('CANVAS'),
                    chartContainer = document.createElement('DIV'),
                    printContainer = document.createElement('DIV'), image;


                  //  if the given highchart has pie-chart series or is a pie-chart. We redaw the complete graph else
                  //  we use existing highchart's SVG to print the graph to PDF
                  if (hasPie || isPie) {

                      //  setting size for newly created cbart
                      printContainer.style.width = actualWidth + 'px';
                      printContainer.style.height = actualHeight + 'px';

                      //  array containing list of series vsisbility
                      var seriesVisibility;

                      if (hasPie) {
                          //  for chart containing pie-chart we collect the visibility of all the series
                          seriesVisibility = _.map($(element).highcharts().series, function (series) {
                              return series.visible;
                          });
                      } else if (isPie) {
                          //  for pie-chart we collect the visibility of data objects of the first series
                          seriesVisibility = _.map($(element).highcharts().series[0].data, function (data) {
                              return data.visible;
                          });
                      }

                      //  creating a new chart entirely
                      ko.bindingHandlers.atnKoHighchart.update(printContainer, args[1]);

                      if (hasPie) {
                          //  for chart having pie-chart we set the visibility of drawn chart (and the existing chart)
                          //  TODO: remove this fix after fixing sotre-loyality
                          //  a fix only meant for store-loyality
                          //  setting the original visibility for chart series
                          _.delay(function (element, seriesVisibility) {
                              _.forEach($(element).highcharts().series, function (series, index) {
                                  series.setVisible(seriesVisibility[index]);
                              });
                          }, 50, element, seriesVisibility);
                          //  setting the original visibility for series of the new chart
                          _.forEach($(printContainer).highcharts().series, function (series, index) {
                              series.setVisible(seriesVisibility[index]);
                          });

                          //  setting the value of extremes in the new chart using the values from original chart
                          //  this is done in order to replicate scrolling and zooming from original chart
                          var actualHighchart = $(element).highcharts(),
                            printHighchart = $(printContainer).highcharts(),
                            numXAxises = actualHighchart.xAxis.length,
                            numYAxises = actualHighchart.yAxis.length, index, extremes;

                          //  setting the value of extremes for xAxis in the new chart using the values from original chart
                          for (index = 0; index < numXAxises; index++) {
                              extremes = actualHighchart.xAxis[index].getExtremes();
                              printHighchart.xAxis[index].setExtremes(extremes.min, extremes.max);
                          }

                          //  setting the value of extremes for yAxis in the new chart using the values from original chart
                          for (index = 0; index < numYAxises; index++) {
                              extremes = actualHighchart.yAxis[index].getExtremes();
                              printHighchart.yAxis[index].setExtremes(extremes.min, extremes.max);
                          }

                      } else if (isPie) {
                          //  for pie-chart we set the visibility of data objects of the first series for the crated graph
                          _.forEach($(printContainer).highcharts().series[0].data, function (datum, index) {
                              datum.setVisible(seriesVisibility[index]);
                          });
                      }

                      //  collecting new chart's SVG element
                      chartContainer.innerHTML = $(printContainer).highcharts().getSVG({
                          chart: {
                              width: 428,
                              height: 280
                          }
                      });
                  } else {
                      //  collecting existing chart's SVG element
                      chartContainer.innerHTML = $(element).highcharts().getSVG();
                      /**
                       * {
                            chart:{
                                width:actualWidth,
                                height: actualHeight
                            }
                        }
                       */
                  }

                  //  in case X-Axis has to be re-located we relocate in SVG element
                  if (needTransform) {
                      var xAxis = chartContainer.querySelector('.highcharts-xaxis-labels');
                      if (xAxis) {
                          xAxis.setAttribute('transform', 'translate(' + (xDelta) + ',' + (yDelta) + ')');
                      }
                  }
                  //  drawing given chart on canvas
                  canvg(canvas, chartContainer.innerHTML);
                  //  return corresponding JPEG image
                  image = canvas.toDataURL('png' === type ? 'image/png' : 'image/jpeg');
                  return image;
              };
          }

          function computeGraphObject(value, element) {
              var width = calculateHighchartWidth(element, 500),
                height = calculateHighchartHeight(element, 400),
                data, isLoading, options;
              if (value && value.model && value.model.modelData) {
                  data = ko.toJS(value.model.modelData);
                  isLoading = ko.utils.unwrapObservable(value.model.isLoading);
                  options = ko.toJS(value.model.options);
              }
              var chartObj = value.template(data, width, height, options);
              return chartObj;
          }

          /**
           * computes the graph height, needed for graph height related computation
           * @param  {domNode} element       element on which hightchart is beoing drawn
           * @param  {integer} defaultHeight default height of the highchart
           * @return {integer}               height of the highchart
           */
          function calculateHighchartHeight(element, defaultHeight) {
              //  TODO set it back to 400
              var elementHeight = parseFloat(element.style.height);
              if (_.isNaN(elementHeight)) {
                  elementHeight = 280;
                  element.style.height = elementHeight + 'px';
              }
              return elementHeight;
          }

          /**
           * computes the graph width, needed for graph width related computation
           * @param  {domNode} element       element on which hightchart is beoing drawn
           * @param  {integer} defaultWidth  default width of the highchart
           * @return {integer}               width of the highchart
           */
          function calculateHighchartWidth(element, defaultWidth) {
              var node = element,
                elementStyleWidth = parseFloat(element.style.width),
                elementWidth = node.offsetWidth || (!_.isNaN(elementStyleWidth) && elementStyleWidth);
              if (!elementWidth) {
                  while (!node.offsetWidth) {
                      node = node.parentElement;
                  }
                  elementWidth = 0.95 * node.offsetWidth;
              }
              //  TODO: remove this
              elementWidth = 530 - 2;
              element.style.width = elementWidth + 'px';
              var width = element.offsetWidth;
              if (!width && element.querySelector('.highcharts-container')) {
                  width = parseInt(element.querySelector('.highcharts-container').style.width, 10);
              }
              if (!width) {
                  width = defaultWidth;
              }
              return elementWidth + 'px';
          }
      }
  });
